export default __webpack_public_path__ + "static/media/spaceShipA4.5f078b79.webp";